__turbopack_context__.v({
  "contacts-container": "S-92-G_contacts-container",
  "default": "S-92-G_default",
  "link": "S-92-G_link",
  "title": "S-92-G_title",
  "title-link-container": "S-92-G_title-link-container",
});
